<template></template>

<script lang="ts">
import { defineComponent } from 'vue';
import { setParticipations } from './Participations';
import type { CampaignLinkParticipations } from './Types';
import { events } from '@/src/services/events';
import type { RegistrationApiResponse } from '@/src/components/addons/registration/types';

export interface CampaignLinkRegistrationResponse extends RegistrationApiResponse {
  participations?: CampaignLinkParticipations;
}

export default defineComponent({
  name: 'GameCampaignLinkInitializer',
  setup() {
    events.on('formSubmitResponse', (event) => {
      const response: CampaignLinkRegistrationResponse = event.detail.response;

      if (response.participations) {
        for (const key in response.participations) {
          if (Object.prototype.hasOwnProperty.call(response.participations, key)) {
            setParticipations(key, { [`${key}`]: response.participations[`${key}`] });
          }
        }
      }
    });

    return {};
  }
});
</script>
